(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("ProtvistaZoomable"), require("ProtvistaUtils"), require("d3"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "ProtvistaZoomable", "ProtvistaUtils", "d3"], factory);
	else if(typeof exports === 'object')
		exports["ProtvistaMsa"] = factory(require("react"), require("react-dom"), require("ProtvistaZoomable"), require("ProtvistaUtils"), require("d3"));
	else
		root["ProtvistaMsa"] = factory(root["React"], root["ReactDOM"], root["ProtvistaZoomable"], root["ProtvistaUtils"], root["d3"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__27__, __WEBPACK_EXTERNAL_MODULE__32__, __WEBPACK_EXTERNAL_MODULE__33__) {
return 